module.exports = __webpack_public_path__ + "img/linkedin.48633158.svg";